import constants from './constants'
import axios from 'axios'
import { setAuthRedirectUrlCookie } from './helper'
import store from './store'

class ApiClient {
  constructor (config) {
    const http = axios.create(config)

    /**
     * @deprecated
     */
    http.interceptors.request.use(
      config => {
        if (['get', 'post'].includes(config.method) && !isNaN(store.state.seo.projects.selectedClientId)) {
          config.params = config.params || {}
          config.params.client_id = store.state.seo.projects.selectedClientId
        }

        return config
      },
      error => Promise.reject(error)
    )

    // Прокидываем выбранного в impersonation клиента в каждый GET/POST-запрос query-параметром
    // _impersonate — бэкенд по нему отдаёт данные от лица этого клиента.
    http.interceptors.request.use(
      config => {
        const impersonatedClientLogin = store.state.impersonation && store.state.impersonation.selectedClientLogin
        if (impersonatedClientLogin && ['get', 'post'].includes(config.method)) {
          config.params = config.params || {}
          config.params._impersonate = impersonatedClientLogin
        }

        return config
      },
      error => Promise.reject(error)
    )

    http.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          // deprecated
          localStorage.removeItem('selectedClientId')

          localStorage.removeItem('impersonationClientLogin')
          setAuthRedirectUrlCookie()
          window.location = constants.AUTH_URL
        }

        return Promise.reject(error)
      })

    return http
  }
}

export default ApiClient
